export default "__VITE_ASSET__CNEdu9Iv__"